import React, {useState, useRef, Fragment} from 'react';
import './index.scss';

const FedEx = () => {
    return(
        <p>Fed ex page works!</p>
    )
}

export default FedEx;